export default __webpack_public_path__ + "static/fangting2-6ea67ec36ec1baa080ce4bfbbe283443.jpg";